import { debounce } from "lodash";
import { useLayoutEffect, useState } from "react";

const desktopBreakPoint = 833;

export const useIsDesktop = (): boolean => {
  const [isDesktop, setIsDesktop] = useState(
    window.innerWidth > desktopBreakPoint,
  );

  useLayoutEffect(() => {
    const updateSize = (): void => {
      setIsDesktop(window.innerWidth > desktopBreakPoint);
    };
    window.addEventListener("resize", debounce(updateSize, 250));

    return (): void => window.removeEventListener("resize", updateSize);
  }, []);

  return isDesktop;
};
